































































import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { OrderService, Order, OrderExternalStatus, UserService, OrderToAcceptData } from '@/api'
import helpers from '@/helpers'
import Status from '@/components/lk/Status.vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

@Component({ components: { Status } })
export default class OrderAccept extends Vue {
  public order: Order | null = null
  public OrderExternalStatus = OrderExternalStatus
  @Prop(String) id!: string
  public token = ''

  public parsedID = 1

  public showPrice = 'main';

  @Watch('id')
  idChanged () {
    this.parsedID = this.getID(this.id)
    this.getOrder()
  }

  getID (val: string): number {
    const id = Number.parseInt(val, 10)
    if (Number.isNaN(id)) {
      return 1
    }

    return id
  }

  mounted () {
    this.parsedID = this.getID(this.id)

    if (!this.$cookies.isKey('token')) {
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has('token')) {
        const token = urlParams.get('token')
        this.$cookies.set('token', token, { expires: '10y' })

        if (token !== null) {
          this.token = token
        }

        UserService.getUserSelf().then(user => {
          this.$store.commit('authorize')
          this.$store.commit('setEmail', user.email)
          this.$store.commit('setDiscount', user.discount)
          this.$store.commit('setPhone', user.phone)
          this.$store.commit('setID', user.id)

          this.getOrder()
        })
      }

      return
    }

    const token = this.$cookies.get('token')

    if (token !== null && typeof token === 'string') {
      this.token = token
    }

    this.getOrder()
  }

  getOrder () {
    OrderService.getOrder({ id: this.parsedID }).then(value => {
      this.order = value
    })
  }

  public formatDate (val: string | undefined): string {
    return helpers.formatDateDay(val)
  }

  public cancel () {
    if (this.order) {
      // eslint-disable-next-line
      this.order.external_status = OrderExternalStatus.CANCELLED
    }

    OrderService.orderAccept({ id: this.parsedID, requestBody: { accepted: false, call: false } }).then(() => {
      this.$router.push('/order/current.html')
    })
  }

  public accept () {
    if (this.order) {
      // eslint-disable-next-line
      this.order.external_status = OrderExternalStatus.TO_PREPAY
    }

    const data: OrderToAcceptData = { accepted: true, call: false }

    OrderService.orderAccept({ id: this.parsedID, requestBody: data }).then(() => {
      this.$router.push('/order/current.html')
    })
  }

  public acceptChangeDate (changeType: string) {
    if (!this.order) {
      return
    }

    // eslint-disable-next-line
    this.order.external_status = OrderExternalStatus.TO_PREPAY

    const data: OrderToAcceptData = { accepted: true, call: false }

    // eslint-disable-next-line
    data.change_type = changeType
    data.price = this.getPrice(changeType)
    data.date = this.getDateNative(changeType)

    OrderService.orderAccept({ id: this.parsedID, requestBody: data }).then(() => {
      this.$router.push('/order/current.html')
    })
  }

  public call () {
    if (this.order) {
      // eslint-disable-next-line
      this.order.external_status = OrderExternalStatus.TO_CALL
    }

    OrderService.orderAccept({ id: this.parsedID, requestBody: { accepted: true, call: true } }).then(() => {
      this.$router.push('/order/current.html')
    })
  }

  get email (): string {
    return this.$store.getters.email
  }

  // Also change this in prepodam calculator
  // And in xvostov api
  public getPrice (showPrice: string): number {
    if (!this.order) {
      return 0
    }

    const now = dayjs().tz('Europe/Moscow')
    const nowTrunced = now.hour(23).minute(0).second(0)

    // second = 1 to get strict delta=1 if one day diff
    const finish = dayjs(this.order.finish_date).tz('Europe/Moscow').hour(23).minute(0).second(1)

    let delta = finish.diff(nowTrunced, 'days')

    if (now.hour() >= 20 && delta > 0) {
      delta -= 1
    }

    if (this.order.type === 'Курсовая работа' || this.order.type === 'Курсовой проект') {
      if (showPrice === 'date1' && delta <= 2) {
        return this.order.price - 500
      } else if (showPrice === 'date2' && delta > 2 && delta <= 4) {
        return this.order.price - 500
      } else if (showPrice === 'date2' && delta <= 4) {
        return this.order.price - 1000
      }
    } else if (this.order.type === 'Реферат') {
      if (showPrice === 'date1' && delta <= 3) {
        return this.order.price - 500
      }
    } else if (this.order.type === 'Дипломная работа') {
      if (showPrice === 'date1' && delta <= 4) {
        return this.order.price - 2000
      } else if (showPrice === 'date2' && delta > 4 && delta <= 10) {
        return this.order.price - 2000
      } else if (showPrice === 'date2' && delta <= 10) {
        return this.order.price - 3000
      }
    }

    return this.order.price
  }

  // Also change this in prepodam calculator
  // And in xvostov api
  public getDate (showPrice: string): string {
    if (!this.order) {
      return ''
    }

    const now = dayjs().tz('Europe/Moscow')
    const nowTrunced = now.hour(23).minute(0).second(0)

    // second = 1 to get strict delta=1 if one day diff
    const finish = dayjs(this.order.finish_date).tz('Europe/Moscow').hour(23).minute(0).second(1)

    let delta = finish.diff(nowTrunced, 'days')

    if (now.hour() >= 20 && delta > 0) {
      delta -= 1
    }

    if (this.order.type === 'Курсовая работа' || this.order.type === 'Курсовой проект') {
      if (showPrice === 'date1' && delta <= 2) {
        return nowTrunced.add(2 + 2, 'days').tz(dayjs.tz.guess()).format('DD.MM.YYYY')
      } else if (showPrice === 'date2' && delta <= 4) {
        return nowTrunced.add(4 + 2, 'days').tz(dayjs.tz.guess()).format('DD.MM.YYYY')
      }
    } else if (this.order.type === 'Реферат') {
      if (showPrice === 'date1' && delta <= 3) {
        return nowTrunced.add(3 + 2, 'days').tz(dayjs.tz.guess()).format('DD.MM.YYYY')
      }
    } else if (this.order.type === 'Дипломная работа') {
      if (showPrice === 'date1' && delta <= 4) {
        return nowTrunced.add(4 + 2, 'days').tz(dayjs.tz.guess()).format('DD.MM.YYYY')
      } else if (showPrice === 'date2' && delta <= 10) {
        return nowTrunced.add(10 + 2, 'days').tz(dayjs.tz.guess()).format('DD.MM.YYYY')
      }
    }

    return ''
  }

  // Also change this in prepodam calculator
  // And in xvostov api
  public getDateNative (showPrice: string): string {
    if (!this.order) {
      return ''
    }

    const now = dayjs().tz('Europe/Moscow')
    const nowTrunced = now.hour(23).minute(0).second(0)

    // second = 1 to get strict delta=1 if one day diff
    const finish = dayjs(this.order.finish_date).tz('Europe/Moscow').hour(23).minute(0).second(1)

    let delta = finish.diff(nowTrunced, 'days')

    if (now.hour() >= 20 && delta > 0) {
      delta -= 1
    }

    if (this.order.type === 'Курсовая работа' || this.order.type === 'Курсовой проект') {
      if (showPrice === 'date1' && delta <= 2) {
        return nowTrunced.add(2 + 2, 'days').tz(dayjs.tz.guess()).toISOString()
      } else if (showPrice === 'date2' && delta <= 4) {
        return nowTrunced.add(4 + 2, 'days').tz(dayjs.tz.guess()).toISOString()
      }
    } else if (this.order.type === 'Реферат') {
      if (showPrice === 'date1' && delta <= 3) {
        return nowTrunced.add(3 + 2, 'days').tz(dayjs.tz.guess()).toISOString()
      }
    } else if (this.order.type === 'Дипломная работа') {
      if (showPrice === 'date1' && delta <= 4) {
        return nowTrunced.add(4 + 2, 'days').tz(dayjs.tz.guess()).toISOString()
      } else if (showPrice === 'date2' && delta <= 10) {
        return nowTrunced.add(10 + 2, 'days').tz(dayjs.tz.guess()).toISOString()
      }
    }

    return ''
  }
}
